import { render } from "./Quote.vue?vue&type=template&id=80de7af4"
import script from "./Quote.vue?vue&type=script&lang=js"
export * from "./Quote.vue?vue&type=script&lang=js"

import "./Quote.vue?vue&type=style&index=0&id=80de7af4&lang=css"

import exportComponent from "C:\\Users\\IanFlew\\Documents\\Projects\\Fleetcare Configurator\\fleetcare-configurator-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__